<template>
    <div class="dashboard-container">
      <!-- 筛选条件区域 -->
      <el-card class="filter-container">
        <div class="filter-item">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
          
          <el-select v-model="department" placeholder="科室选择" style="width: 150px; margin-left: 10px">
            <el-option v-for="item in departmentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-select v-model="patientType" placeholder="患者类型" style="width: 150px; margin-left: 10px">
            <el-option v-for="item in patientTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleSearch">查询</el-button>
          <el-button type="success" icon="el-icon-refresh" style="margin-left: 10px" @click="handleRefresh">刷新</el-button>
        </div>
      </el-card>
      
      <!-- 个人工作概览 -->
      <el-row :gutter="20" class="panel-group">
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-task">
              <i class="el-icon-s-claim card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">今日待处理任务</div>
              <div class="card-panel-num">12</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-completed">
              <i class="el-icon-check card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">本周任务完成率</div>
              <div class="card-panel-num">86.5%</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-warn">
              <i class="el-icon-warning card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">高风险患者</div>
              <div class="card-panel-num">5人</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-message">
              <i class="el-icon-chat-dot-round card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">未回复留言</div>
              <div class="card-panel-num">8条</div>
            </div>
          </div>
        </el-col>
      </el-row>
      
      <!-- 图表展示区域 - 第一行 -->
      <el-row :gutter="20">
        <!-- 随访任务执行统计 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>随访任务执行统计</span>
              <el-radio-group v-model="taskStatPeriod" size="mini" @change="changeTaskStatPeriod">
                <el-radio-button label="day">日</el-radio-button>
                <el-radio-button label="week">周</el-radio-button>
                <el-radio-button label="month">月</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="taskStatChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 患者反馈监控 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者反馈实时监控</span>
              <el-dropdown @command="handleFeedbackTypeChange">
                <span class="el-dropdown-link">
                  {{ feedbackType === 'scale' ? '量表填写情况' : '满意度分布' }} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="scale">量表填写情况</el-dropdown-item>
                  <el-dropdown-item command="satisfaction">满意度分布</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="chart" id="patientFeedbackChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 图表展示区域 - 第二行 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 患者风险预警处理跟踪 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者风险预警处理跟踪</span>
              <el-radio-group v-model="riskViewMode" size="mini" @change="changeRiskViewMode">
                <el-radio-button label="radar">雷达图</el-radio-button>
                <el-radio-button label="heat">热力图</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="patientRiskChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 医护沟通统计 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>医护沟通统计</span>
            </div>
            <div class="chart" id="communicationChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 高风险患者列表 -->
      <el-card class="warning-container" style="margin-top: 20px">
        <div slot="header" class="warning-header">
          <span><i class="el-icon-warning" style="color: #E6A23C"></i> 高风险患者提醒</span>
          <el-tag type="danger">需要优先处理</el-tag>
        </div>
        
        <el-table :data="highRiskPatients" border style="width: 100%">
          <el-table-column prop="name" label="患者姓名" width="120"></el-table-column>
          <el-table-column prop="age" label="年龄" width="80"></el-table-column>
          <el-table-column prop="department" label="科室" width="120"></el-table-column>
          <el-table-column prop="disease" label="疾病" width="140"></el-table-column>
          <el-table-column prop="riskLevel" label="风险等级" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.riskLevel === '高' ? 'danger' : scope.row.riskLevel === '中' ? 'warning' : 'info'">
                {{ scope.row.riskLevel }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="riskFactor" label="风险因素" min-width="200"></el-table-column>
          <el-table-column prop="lastContact" label="上次联系时间" width="160"></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="handleContact(scope.row)">立即联系</el-button>
              <el-button type="success" size="mini" @click="handlePlanIntervention(scope.row)">制定干预计划</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      
      <!-- 工作安排 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <el-col :span="12">
          <el-card class="task-container">
            <div slot="header" class="task-header">
              <span><i class="el-icon-date"></i> 今日工作安排</span>
              <el-button type="text" icon="el-icon-plus" @click="addTask">添加任务</el-button>
            </div>
            
            <el-timeline>
              <el-timeline-item
                v-for="(task, index) in todayTasks"
                :key="index"
                :timestamp="task.time"
                :type="task.status === '完成' ? 'success' : task.status === '进行中' ? 'primary' : 'warning'">
                <div class="task-item">
                  <div class="task-title">{{ task.title }}</div>
                  <div class="task-desc">{{ task.description }}</div>
                  <div class="task-footer">
                    <el-tag size="mini" :type="task.status === '完成' ? 'success' : task.status === '进行中' ? 'primary' : 'warning'">{{ task.status }}</el-tag>
                    <el-button v-if="task.status !== '完成'" type="text" @click="completeTask(index)">标记完成</el-button>
                  </div>
                </div>
              </el-timeline-item>
            </el-timeline>
          </el-card>
        </el-col>
        
        <el-col :span="12">
          <el-card class="performance-container">
            <div slot="header">
              <span><i class="el-icon-s-data"></i> 绩效情况</span>
            </div>
            
            <div class="performance-metrics">
              <div class="metric-item">
                <div class="metric-name">患者随访数</div>
                <el-progress :percentage="78" :format="format"></el-progress>
              </div>
              <div class="metric-item">
                <div class="metric-name">按时完成率</div>
                <el-progress :percentage="92" :format="format" status="success"></el-progress>
              </div>
              <div class="metric-item">
                <div class="metric-name">患者满意度</div>
                <el-progress :percentage="85" :format="format"></el-progress>
              </div>
              <div class="metric-item">
                <div class="metric-name">异常事件处理</div>
                <el-progress :percentage="95" :format="format" status="success"></el-progress>
              </div>
              <div class="metric-item">
                <div class="metric-name">患者健康改善</div>
                <el-progress :percentage="72" :format="format"></el-progress>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 添加任务对话框 -->
      <el-dialog title="添加任务" :visible.sync="taskDialogVisible" width="500px">
        <el-form :model="newTask" label-width="100px">
          <el-form-item label="任务标题">
            <el-input v-model="newTask.title" placeholder="请输入任务标题"></el-input>
          </el-form-item>
          <el-form-item label="任务描述">
            <el-input v-model="newTask.description" type="textarea" placeholder="请输入任务描述"></el-input>
          </el-form-item>
          <el-form-item label="执行时间">
            <el-time-picker v-model="newTask.timeObj" placeholder="请选择时间" format="HH:mm"></el-time-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="taskDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveTask">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts'
  
  export default {
    name: 'PersonalManager',
    data() {
      return {
        // 筛选条件
        dateRange: ['2024-05-01', '2024-05-31'],
        department: '全部',
        patientType: '全部',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        departmentOptions: [
          { value: '全部', label: '全部' },
          { value: '呼吸科', label: '呼吸科' },
          { value: '肿瘤科', label: '肿瘤科' },
          { value: '心内科', label: '心内科' },
          { value: '消化科', label: '消化科' }
        ],
        patientTypeOptions: [
          { value: '全部', label: '全部' },
          { value: '门诊患者', label: '门诊患者' },
          { value: '住院患者', label: '住院患者' },
          { value: '术后患者', label: '术后患者' }
        ],
        
        // 图表实例
        taskStatChart: null,
        patientFeedbackChart: null,
        patientRiskChart: null,
        communicationChart: null,
        
        // 控制参数
        taskStatPeriod: 'week',
        feedbackType: 'scale',
        riskViewMode: 'radar',
        
        // 高风险患者数据
        highRiskPatients: [
          { name: '许昊然', age: 67, department: '肿瘤科', disease: '肺癌术后', riskLevel: '高', riskFactor: '术后3天出现发热，药物不良反应风险', lastContact: '2024-05-15 09:30' },
          { name: '苏雅婷', age: 72, department: '心内科', disease: '冠心病', riskLevel: '高', riskFactor: '近期血压波动大，服药依从性差', lastContact: '2024-05-14 16:45' },
          { name: '林书辰', age: 58, department: '呼吸科', disease: 'COPD', riskLevel: '中', riskFactor: '呼吸困难症状加重，有吸烟史', lastContact: '2024-05-13 11:20' },
          { name: '程若曦', age: 45, department: '消化科', disease: '肝硬化', riskLevel: '高', riskFactor: '近期饮食不规律，肝功能指标异常', lastContact: '2024-05-16 10:15' },
          { name: '季泽铭', age: 63, department: '肿瘤科', disease: '乳腺癌术后', riskLevel: '中', riskFactor: '术后恢复不佳，心理状态波动', lastContact: '2024-05-15 14:30' }
        ],
        
        // 今日任务
        todayTasks: [
          { time: '09:00', title: '高风险患者随访', description: '对3位肿瘤科术后高风险患者进行电话随访', status: '完成' },
          { time: '10:30', title: '量表数据分析', description: '整理分析患者提交的健康自评量表数据，识别异常情况', status: '完成' },
          { time: '13:30', title: '患者健康教育讲座', description: '为心内科患者进行线上健康教育讲座', status: '进行中' },
          { time: '15:00', title: '医生沟通会议', description: '与科室医生讨论高风险患者干预方案', status: '待处理' },
          { time: '16:30', title: '回复患者留言', description: '处理患者在系统中提出的问题和咨询', status: '待处理' }
        ],
        
        // 添加任务相关
        taskDialogVisible: false,
        newTask: {
          title: '',
          description: '',
          timeObj: null,
          status: '待处理'
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initCharts()
      })
    },
    methods: {
      // 筛选和刷新
      handleSearch() {
        this.$message.success('筛选条件已应用')
        this.refreshCharts()
      },
      
      handleRefresh() {
        this.$message.success('数据已刷新')
        this.refreshCharts()
      },
      
      // 图表初始化方法
      initCharts() {
        this.initTaskStatChart()
        this.initPatientFeedbackChart()
        this.initPatientRiskChart()
        this.initCommunicationChart()
        
        window.addEventListener('resize', this.resizeCharts)
      },
      
      // 图表切换视图
      changeTaskStatPeriod() {
        this.initTaskStatChart()
      },
      
      handleFeedbackTypeChange(type) {
        this.feedbackType = type
        this.initPatientFeedbackChart()
      },
      
      changeRiskViewMode() {
        this.initPatientRiskChart()
      },
      
      // 随访任务执行统计图表
      initTaskStatChart() {
        if (this.taskStatChart) {
          this.taskStatChart.dispose()
        }
        
        this.taskStatChart = echarts.init(document.getElementById('taskStatChart'))
        
        let xAxisData = []
        let plannedData = []
        let completedData = []
        
        if (this.taskStatPeriod === 'day') {
          xAxisData = ['8:00', '9:00', '10:00', '11:00', '13:00', '14:00', '15:00', '16:00', '17:00']
          plannedData = [2, 4, 5, 3, 4, 5, 3, 2, 1]
          completedData = [2, 3, 5, 2, 3, 4, 2, 1, 0]
        } else if (this.taskStatPeriod === 'week') {
          xAxisData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          plannedData = [15, 13, 18, 16, 14, 8, 5]
          completedData = [14, 11, 17, 13, 12, 7, 4]
        } else {
          xAxisData = ['1月', '2月', '3月', '4月', '5月']
          plannedData = [60, 58, 72, 65, 68]
          completedData = [54, 52, 68, 60, 62]
        }
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['计划任务', '完成任务'],
            right: 10
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xAxisData
          },
          yAxis: {
            type: 'value',
            name: '任务数'
          },
          series: [
            {
              name: '计划任务',
              type: 'bar',
              data: plannedData,
              itemStyle: {
                color: '#409EFF'
              }
            },
            {
              name: '完成任务',
              type: 'line',
              data: completedData,
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {
                color: '#67C23A'
              },
              lineStyle: {
                width: 3
              }
            }
          ]
        }
        
        this.taskStatChart.setOption(option)
      },
      
      // 患者反馈实时监控图表
      initPatientFeedbackChart() {
        if (this.patientFeedbackChart) {
          this.patientFeedbackChart.dispose()
        }
        
        this.patientFeedbackChart = echarts.init(document.getElementById('patientFeedbackChart'))
        
        let option = {}
        
        if (this.feedbackType === 'scale') {
          option = {
            tooltip: {
              trigger: 'axis'
            },
            legend: {
              data: ['量表完成数', '未完成数'],
              right: 10
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: ['5-10', '5-11', '5-12', '5-13', '5-14', '5-15', '5-16']
            },
            yAxis: {
              type: 'value',
              name: '患者数量'
            },
            series: [
              {
                name: '量表完成数',
                type: 'line',
                stack: '总量',
                areaStyle: { opacity: 0.3 },
                data: [15, 18, 12, 20, 16, 19, 22],
                itemStyle: {
                  color: '#409EFF'
                }
              },
              {
                name: '未完成数',
                type: 'line',
                stack: '总量',
                areaStyle: { opacity: 0.3 },
                data: [5, 3, 8, 2, 6, 4, 3],
                itemStyle: {
                  color: '#F56C6C'
                }
              }
            ]
          }
        } else {
          option = {
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
              orient: 'vertical',
              right: 10,
              top: 'center',
              data: ['非常满意', '满意', '一般', '不满意', '非常不满意']
            },
            series: [
              {
                name: '患者满意度',
                type: 'pie',
                radius: ['45%', '70%'],
                avoidLabelOverlap: false,
                label: {
                  show: true,
                  formatter: '{b}: {d}%'
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: '16',
                    fontWeight: 'bold'
                  }
                },
                data: [
                  { value: 60, name: '非常满意' },
                  { value: 30, name: '满意' },
                  { value: 8, name: '一般' },
                  { value: 1, name: '不满意' },
                  { value: 1, name: '非常不满意' }
                ],
                color: ['#67C23A', '#409EFF', '#E6A23C', '#F56C6C', '#909399']
              }
            ]
          }
        }
        
        this.patientFeedbackChart.setOption(option)
      },
      
      // 患者风险预警处理跟踪图表
      initPatientRiskChart() {
        if (this.patientRiskChart) {
          this.patientRiskChart.dispose()
        }
        
        this.patientRiskChart = echarts.init(document.getElementById('patientRiskChart'))
        
        let option = {}
        
        if (this.riskViewMode === 'radar') {
          option = {
            tooltip: {},
            legend: {
              data: ['干预前', '干预后'],
              right: 10
            },
            radar: {
              shape: 'circle',
              indicator: [
                { name: '生命体征', max: 10 },
                { name: '服药依从性', max: 10 },
                { name: '心理状态', max: 10 },
                { name: '生活自理', max: 10 },
                { name: '健康认知', max: 10 },
                { name: '并发症风险', max: 10 }
              ]
            },
            series: [
              {
                type: 'radar',
                name: '风险改善情况',
                data: [
                  {
                    value: [3, 4, 3, 5, 2, 3],
                    name: '干预前',
                    areaStyle: {
                      color: 'rgba(255, 87, 51, 0.4)'
                    },
                    lineStyle: {
                      color: '#F56C6C'
                    }
                  },
                  {
                    value: [7, 8, 6, 7, 6, 8],
                    name: '干预后',
                    areaStyle: {
                      color: 'rgba(103, 194, 58, 0.4)'
                    },
                    lineStyle: {
                      color: '#67C23A'
                    }
                  }
                ]
              }
            ]
          }
        } else {
          // 热力图数据
          const hours = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23']
          const days = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          
          const data = []
          let baseValue = Math.random() * 10
          
          for (let i = 0; i < days.length; i++) {
            for (let j = 0; j < hours.length; j++) {
              const point = [j, i]
              if (j >= 8 && j <= 18) {
                point.push(Math.round(Math.random() * 8 + 2))
              } else {
                point.push(Math.round(Math.random() * 2))
              }
              
              data.push(point)
            }
          }
          
          option = {
            tooltip: {
              position: 'top',
              formatter: function (params) {
                return `${days[params.value[1]]} ${hours[params.value[0]]}时: ${params.value[2]} 例`
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              data: hours,
              splitArea: {
                show: true
              },
              name: '小时'
            },
            yAxis: {
              type: 'category',
              data: days,
              splitArea: {
                show: true
              },
              name: '星期'
            },
            visualMap: {
              min: 0,
              max: 10,
              calculable: true,
              orient: 'horizontal',
              left: 'center',
              bottom: '0%',
              inRange: {
                color: ['#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196127']
              }
            },
            series: [
              {
                name: '风险事件热力图',
                type: 'heatmap',
                data: data,
                label: {
                  show: false
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  }
                }
              }
            ]
          }
        }
        
        this.patientRiskChart.setOption(option)
      },
      
      // 医护沟通统计图表
      initCommunicationChart() {
        if (this.communicationChart) {
          this.communicationChart.dispose()
        }
        
        this.communicationChart = echarts.init(document.getElementById('communicationChart'))
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['24小时内', '48小时内', '超过48小时']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            name: '回复数量'
          },
          yAxis: {
            type: 'category',
            data: ['疾病咨询', '用药问题', '复诊安排', '日常护理', '异常反应', '健康指导']
          },
          series: [
            {
              name: '24小时内',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: [28, 22, 19, 31, 34, 25],
              itemStyle: {
                color: '#67C23A'
              }
            },
            {
              name: '48小时内',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: [12, 9, 14, 5, 8, 10],
              itemStyle: {
                color: '#E6A23C'
              }
            },
            {
              name: '超过48小时',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'inside'
              },
              emphasis: {
                focus: 'series'
              },
              data: [3, 2, 4, 2, 5, 3],
              itemStyle: {
                color: '#F56C6C'
              }
            }
          ]
        }
        
        this.communicationChart.setOption(option)
      },
      
      // 刷新所有图表
      refreshCharts() {
        this.initTaskStatChart()
        this.initPatientFeedbackChart()
        this.initPatientRiskChart()
        this.initCommunicationChart()
      },
      
      // 适应窗口大小变化
      resizeCharts() {
        this.taskStatChart && this.taskStatChart.resize()
        this.patientFeedbackChart && this.patientFeedbackChart.resize()
        this.patientRiskChart && this.patientRiskChart.resize()
        this.communicationChart && this.communicationChart.resize()
      },
      
      // 高风险患者操作
      handleContact(row) {
        this.$message.success(`正在联系患者：${row.name}`)
      },
      
      handlePlanIntervention(row) {
        this.$message.success(`正在为患者 ${row.name} 制定干预计划`)
      },
      
      // 任务管理
      addTask() {
        this.newTask = {
          title: '',
          description: '',
          timeObj: null,
          status: '待处理'
        }
        this.taskDialogVisible = true
      },
      
      saveTask() {
        if (!this.newTask.title || !this.newTask.timeObj) {
          this.$message.error('任务标题和时间不能为空')
          return
        }
        
        const hours = this.newTask.timeObj.getHours().toString().padStart(2, '0')
        const minutes = this.newTask.timeObj.getMinutes().toString().padStart(2, '0')
        const time = `${hours}:${minutes}`
        
        this.todayTasks.push({
          time,
          title: this.newTask.title,
          description: this.newTask.description,
          status: '待处理'
        })
        
        // 按时间排序
        this.todayTasks.sort((a, b) => {
          return a.time.localeCompare(b.time)
        })
        
        this.taskDialogVisible = false
        this.$message.success('任务添加成功')
      },
      
      completeTask(index) {
        this.todayTasks[index].status = '完成'
        this.$message.success('任务已标记为完成')
      },
      
      // 格式化进度条
      format(percentage) {
        return percentage + '%'
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeCharts)
      this.taskStatChart && this.taskStatChart.dispose()
      this.patientFeedbackChart && this.patientFeedbackChart.dispose()
      this.patientRiskChart && this.patientRiskChart.dispose()
      this.communicationChart && this.communicationChart.dispose()
    }
  }
  </script>
  
  <style scoped>
  .dashboard-container {
    padding: 20px;
  }
  
  .filter-container {
    margin-bottom: 20px;
  }
  
  .filter-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  
  /* 指标卡片样式 */
  .panel-group {
    margin: 20px 0;
  }
  
  .card-panel-col {
    margin-bottom: 20px;
  }
  
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border-color: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
  }
  
  .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    border-radius: 8px;
    transition: all 0.38s ease-out;
  }
  
  .card-panel-icon {
    float: left;
    font-size: 32px;
    color: #fff;
  }
  
  .icon-task {
    background: #40c9c6;
  }
  
  .icon-completed {
    background: #36a3f7;
  }
  
  .icon-warn {
    background: #f4516c;
  }
  
  .icon-message {
    background: #34bfa3;
  }
  
  .card-panel-description {
    float: right;
    font-weight: bold;
    margin: 26px 26px 0 0;
  }
  
  .card-panel-text {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 12px;
  }
  
  .card-panel-num {
    font-size: 24px;
    font-weight: 600;
  }
  
  /* 图表区域样式 */
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  
  /* 高风险患者提醒 */
  .warning-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* 任务列表样式 */
  .task-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .task-item {
    padding: 5px 0;
  }
  
  .task-title {
    font-weight: bold;
    font-size: 14px;
    margin-bottom: 5px;
  }
  
  .task-desc {
    font-size: 13px;
    color: #606266;
    margin-bottom: 8px;
  }
  
  .task-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* 绩效指标样式 */
  .performance-metrics {
    padding: 15px 0;
  }
  
  .metric-item {
    margin-bottom: 25px;
  }
  
  .metric-name {
    font-size: 14px;
    color: #606266;
    margin-bottom: 8px;
  }
  </style>